import { config } from '~app/config';

import { makeRequest } from '~shared/api/make-request';

import { ResponseSuccess } from '@breezeventures/scp-client';
import { useQuery } from '@tanstack/react-query';

import { mallKeys } from './mall-keys';

import type { Mall } from '../model';

export const useMalls = <TSelect = Mall[]>(options?: {
  select?: (malls: Mall[]) => TSelect;
}) => {
  return useQuery({
    queryKey: mallKeys.list(),
    queryFn: () => {
      return makeRequest<ResponseSuccess<Mall[]>>({
        url: `${config.apiHost}/merchant-portal/api/v1/partner-onboarding/malls/find-all`,
        credentials: 'include',
        payload: {},
      }).then((response) => response.payload);
    },
    ...options,
  });
};
